import { render, staticRenderFns } from "./StoriesArchiveCard.vue?vue&type=template&id=208969e2&scoped=true&"
import script from "./StoriesArchiveCard.vue?vue&type=script&lang=ts&"
export * from "./StoriesArchiveCard.vue?vue&type=script&lang=ts&"
import style0 from "./StoriesArchiveCard.vue?vue&type=style&index=0&id=208969e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208969e2",
  null
  
)

export default component.exports